import { Divider } from "../../components/Divider";
import { RouteFullScreenModal } from "../../components/RouteFullScreenModal";
import { AddMenuCampaignsForm } from "./components/AddMenuCampaignsForm";

export const AddMenuCampaigns = () => {
  return (
    <RouteFullScreenModal title="Add campaign to menu">
      <Divider />
      <AddMenuCampaignsForm />
    </RouteFullScreenModal>
  );
};
